import React, { FC, useState } from "react";
import styled from "styled-components";

import { Popup } from "./common/Popup";
import { JsonSchemaForm } from "./JsonSchemaForm";
import { JsonSchema, ServiceParameters } from "./JsonSchemaForm/types";

export interface IPromptPopup {
    schema: JsonSchema;
    okText?: string;
    cancelText?: string;
    onComplete: (config: string) => void;
    onCancel: () => void;
}

export const PromptPopup: FC<IPromptPopup> = (props: IPromptPopup) => {
    const { schema, onComplete, onCancel, okText, cancelText } = props;
    const [params, setParams] = useState<ServiceParameters>({});
    const [currentPath, setCurrentPath] = useState<string[]>([]);

    return (
        <>
            {schema && params && (
                <Container>
                    <Popup
                        visible={true}
                        windowClassName="window"
                        onClose={onCancel}
                    >
                        <JsonSchemaForm
                            okText={okText}
                            cancelText={cancelText}
                            schema={schema}
                            params={params}
                            path={[]}
                            setParams={setParams}
                            currentPath={currentPath}
                            setCurrentPath={setCurrentPath}
                            onCancel={onCancel}
                            onSave={onComplete}
                        />
                    </Popup>
                </Container>
            )}
        </>
    );
};

const Container = styled.div`
    .window {
        width: 22.5rem;
        min-width: 22.5rem;
        min-height: 33.8125rem;
        height: 33.8125rem;
        padding: 0rem;
        margin: 0rem;
    }
`;
